import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

function onboardingRoutes(): RouteRecordRaw[] {
  return [
    {
      component: () => import('./pages/Feedback.vue'),
      name: ROUTE_NAMES.ONBOARDING.FEEDBACK,
      path: '/bo-seller/onboarding/feedback',
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
  ]
}
const routes = (): RouteRecordRaw[] => {
  return [
    ...onboardingRoutes(),
    {
      component: () => import('./pages/Feedback.vue'),
      name: ROUTE_NAMES.FEEDBACK,
      path: '/bo-seller/feedback',
      children: [],
      meta: {
        autonomousBannerPageName: 'feedback',
        owners: ['bot-squad-seller-experience-front'],
      },
    },
  ]
}

export default routes
